import { useTranslation } from 'react-i18next';
import { Button } from '../../components/Button';
import { Dialog } from '../../components/Dialog';
import { useAuth } from './AuthContext';

/** Kontaktadresse für Verlängerungen des Zugangs. */
const SUBSCRIPTION_MAIL = 'abo@miarto.de';

/**
 * Dialog nach dem Login, wenn der Zugang in höchstens 10 Tagen abläuft (Q8: Abo wird weiter
 * manuell verlängert). Erscheint einmal pro Anmeldung.
 */
export function ExpiryWarning() {
  const { t, i18n } = useTranslation();
  const { user, expiryWarningDays, dismissExpiryWarning } = useAuth();
  const date =
    user?.expiresAt && expiryWarningDays !== null
      ? new Date(user.expiresAt).toLocaleDateString(i18n.language)
      : '';
  return (
    <Dialog
      title={t('expiry.title')}
      isOpen={expiryWarningDays !== null}
      onClose={dismissExpiryWarning}
    >
      <p>{t('expiry.body', { count: expiryWarningDays ?? 0, date })}</p>
      <p>{t('expiry.contact', { mail: SUBSCRIPTION_MAIL })}</p>
      <Button onClick={dismissExpiryWarning}>{t('expiry.ok')}</Button>
    </Dialog>
  );
}
